import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer-forgot-password',
  templateUrl: './customer-forgot-password.component.html',
  styleUrls: ['./customer-forgot-password.component.scss'],
})
export class CustomerForgotPasswordComponent {
  form: FormGroup;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private snack: MatSnackBar,
    private router: Router
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (this.form.invalid) return;

    this.loading = true;

    this.api.post('customer/forgot-password', this.form.value).subscribe({
      next: (res) => {
        this.loading = false;
        this.snack.open('Reset link sent! Check your email.', 'Close', {
          duration: 3000,
        });
        this.router.navigate(['/customers/login']);
      },
      error: (err) => {
        this.loading = false;
        this.snack.open(err.error?.message || 'Something went wrong', 'Close', {
          duration: 4000,
        });
      },
    });
  }
}
